<template>
    <div
        :class="['product-category-item', 'level-' + node.level, {'opened': expandChildren, 'd-none': !isVisible}]"
    >
        <div :class="['product-category-item-title', 'd-flex', {'opened' : expandChildren}]" @click="toggleState">
            <span v-if="hasChildren"><feather-icon :icon="expandChildren ? 'ChevronDownIcon' : 'ChevronRightIcon'" /></span>
            <span class="checkbox icon-padding" v-if="!onlySelectable || (onlySelectable && node.isSelectable)">
                <b-form-checkbox
                    v-model="checked"
                    :value="node.id"
                    @change="onCheckboxClick"
                />
            </span>
            <span class="lead icon-padding" v-html="title"></span>
        </div>
        <div class="product-category-children">
            <div v-if="loading" class="text-center">
                Loading
                <b-spinner small />
            </div>
            <ProductCategoryItem
                ref="children"
                @search="onSearch"
                @change="onParentChange"
                v-for="child in node.children"
                :only-selectable="onlySelectable"
                :selected="selected"
                :searchString="searchString"
                :node="child"
                :parent="node"
                :visible="expandChildren"
            />
        </div>
    </div>
</template>

<script>
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import ProductCategoryCollapseItem from "@core/components/product/ProductCategoryCollapseItem";
import {ProductApi} from '@core/api'
import { BFormGroup, BListGroup, BListGroupItem, BButton, BFormCheckbox, BSpinner, BAlert } from 'bootstrap-vue'

export default {
    name: "ProductCategoryItem",
    components: {
        BFormGroup, BListGroup, BListGroupItem, BButton, BFormCheckbox, BSpinner, BAlert,
        AppCollapse, ProductCategoryCollapseItem,
    },
    props: {
        node: {
            type: Object
        },
        parent: {
            type: Object
        },
        selected: {
            type: Array,
        },
        searchString: {
            default: '',
        },
        visible: {
            type: Boolean,
            default: true
        },
        onlySelectable: {
            default: true
        }
    },
    data() {
        if (this.node.id === 9) {
            console.log('INIT');
        }
        return {
            expandChildren: false,
            checked: this.selected,
            isChildrenLoaded: false,
            loading: false,
            isSearching: false,
            isSearchSuccess: false,
            isParentSearchSucceed: false,
            isChecked: false,
        };
    },
    methods: {
        onSearch(result) {
            this.isParentSearchSucceed = result;

            if (result && !this.expandChildren) {
                this.toggleState();
            }
        },
        onCheckboxClick(id) {
            this.$emit('change', {
                node: this.node,
                parent: this.parent,
                selected: typeof id === 'object' && id.length > 0
            });

            this.isChecked = id !== false;
        },
        onParentChange(e) {
            this.$emit('change', e);
        },
        toggleState() {
            if (!this.hasChildren) {
                return;
            }

            this.expandChildren = !this.expandChildren;

            if (this.node.children.length === 0 && this.isChildrenLoaded === false) {
                this.isChildrenLoaded = true;

                if (this.node.childrenLoaded) {
                    if (this.node.children.length === 0) {
                        this.expandChildren = false;
                    }
                    return;
                }

                this.loading = true;
                ProductApi.getCategoryChildren(this.node.id).then(r => {
                    this.node.children = r.data
                    this.node.childrenLoaded = true;
                    this.loading = false;

                    if (this.node.children.length === 0) {
                        this.expandChildren = false;
                    }
                });
            }
        },
        search(qs) {
            this.isSearching = qs.length > 0;
            this.isSearchSuccess = this.node.title.toLowerCase().indexOf(qs) >= 0;

            if (this.$refs.children) {
                this.$refs.children.forEach(r => {
                    if (r.search(qs)) {
                        this.isSearchSuccess = true;
                        if (!this.expandChildren) {
                            this.toggleState();
                        }
                    }
                });
            }

            return this.isSearchSuccess;
        },
    },
    computed: {
        hasChildren() {
            if (this.node.children.length > 0) {
                return true;
            }

            if (this.loading) {
                return true;
            }

            if (this.node.childrenLoaded && this.node.children.length === 0) {
                return false;
            }

            return !this.isChildrenLoaded;
        },
        title() {
            if (this.isSearchActive && this.isSearchSuccess) {
                return this.node.title.replace(new RegExp('(' + this.searchString + ')', 'i'), "<b>$1</b>");
            }

            return this.node.title;
        },
        isVisible() {
            if (this.isSearching) {
                return this.isSearchSuccess;
            }

            if (this.isChecked) {
                return true;
            }

            return this.visible;
        },
        isSearchActive() {
            return typeof this.searchString === 'string' && this.searchString.length > 0;
        },
    },
    created() {
        this.node.getHierarchy = () => {
            if (this.parent === this.node) {
                return [];
            }
            let hierarchy = this.parent.getHierarchy();
            hierarchy.push(this.parent);

            return hierarchy;
        };
    }
}
</script>

<style lang="scss">
.product-category-item {
    //padding: 0.75rem 1.25rem;
    border-bottom: 1px solid #f1f1f1;

    .product-category-item-title {
        cursor: pointer;
        padding: 1rem;
    }

    .product-category-item-title.opened {
        background-color: #f1f1f1;
    }

    .product-category-item-title span.icon-padding {
        padding-left: 12px;
    }
}
.product-category-item:last-child {
    border: none;
}
.product-category-item.opened > .product-category-children {
    border-color: #ebe9f1;
    border-width: 0 1px 1px 1px;
    border-style: solid;
    padding: 1rem
}
</style>
